import React, { memo } from 'react';
import { scrollToPurchase, CHECKOUT_URL } from '../utils/checkout';
export function HeroSection() {
  return <section className="bg-white pt-4 pb-6 px-4" data-id="element-109">
      <div className="max-w-3xl mx-auto text-center" data-id="element-110">
        <p className="font-sans font-medium text-gray-500 uppercase tracking-wider text-[10px] md:text-xs mb-2" data-id="element-111">
          📱 For dog owners who want beautiful photos without expensive gear
        </p>

        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-3 leading-tight" data-id="element-112">
          The <span className="italic text-soft-gold" data-id="element-113">Pawfect</span> Shot
          MegaPack
        </h1>

        <a href="#purchase" onClick={scrollToPurchase} className="block mb-3 cursor-pointer group" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/bVgFy1FZnNpUoPshVTLQdo/Untitled_design.png" alt="The Pawfect Shot MegaPack" className="w-full max-w-lg mx-auto rounded-lg shadow-xl transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-115" />
        </a>

        <h2 className="font-serif text-xl md:text-2xl font-semibold text-black mb-2" data-id="element-116">
          Take professional-looking photos of your dog with your phone
        </h2>

        <p className="font-sans text-base md:text-lg text-gray-700 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-117">
          Everything you need to capture beautiful, emotional, frame-worthy dog
          photos — without expensive gear, confusing photography jargon, or
          guesswork.
          <br data-id="element-118" />
          <br data-id="element-119" />
          Turn ordinary snapshots into memories worth sharing, keeping, and
          printing.
        </p>

        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-lg md:text-xl py-4 px-10 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 uppercase text-center" data-id="element-120">
          👉 YES, I WANT INSTANT ACCESS NOW
        </button>

        <p className="font-sans text-sm text-gray-500 mt-3 flex items-center justify-center gap-2" data-id="element-121">
          <span className="text-green-600 text-lg" data-id="element-122">✅</span> 7-Day Satisfaction
          Guarantee
        </p>
      </div>
    </section>;
}